<div class="">
  <div class="header-mobile" [class.tw-z-10]="active">
    <p class="open-menu-mobile"><span (click)="this.setMenuStatus(!this.active)"><span nz-icon [nzType]="!active ? 'menu' : 'close'" nzTheme="outline"></span></span></p>
    <h4 class="tw-text-white tw-font-bold"
        [class.tw-text-right]="hasPanelTemplate"
        [class.tw-mr-3]="hasPanelTemplate"
        [class.tw-w-full]="hasPanelTemplate"
    >
      {{ clinic?.name }}
    </h4>
    <div>
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </div>
  </div>
  <div [@collapse]="!active" class=" container-collapse-menu">
    <div class="l-menu-container active">
      <ng-scrollbar class="my-scrollbar">
        <div class="l-menu">
          <div class="l-menu-items">
            <ng-container *ngFor="let menuCategory of this.menu">
              <ng-container *ngIf="menuCategory.visible === undefined ? true : menuCategory.visible">
                <div class="l-menu-category">
                  <h5>{{ menuCategory.name }}</h5>
                </div>

                <ng-container *ngFor="let menuItem of menuCategory?.subItems">
                  <div *ngIf="menuItem.visible === undefined ? true : menuItem.visible"
                       [routerLink]="menuItem.url"
                       [routerLinkActiveOptions]="{exact: true}"
                       [routerLinkActive]="'selected'" [queryParams]="menuItem.params === undefined ? {} : menuItem.params"
                       class="l-menu-item-container">
                    <h5> {{ menuItem.name }} </h5>
                    <i class="{{ menuItem.iconClass }}"></i>
                  </div>
                </ng-container>


              </ng-container>
            </ng-container>
          </div>

          <div class="l-user">
            <ng-container *ngTemplateOutlet="userImage"></ng-container>
            <div class="l-user-name">
              <h3 *ngIf="user">{{ user.name + ' ' + (user.lastname ? user.lastname : '') }}</h3>
              <h3 *ngIf="!user">Usuario no encontrado</h3>
              <div class="l-clinic" nz-dropdown
                   [nzDropdownMenu]="clinicsDropdown" nzTrigger="click" (nzVisibleChange)="onKeepMenuActive($event)">
                <h5>{{ clinic?.name }}</h5>
                <i class="fa-solid fa-caret-down"></i>
              </div>
            </div>
            <div class="l-logout" (click)="this.onLogout()">
              <i class="fa-solid fa-right-from-bracket"></i>
            </div>
          </div>
          <nz-dropdown-menu #clinicsDropdown="nzDropdownMenu">
            <ul nz-menu>
              <li class="dropdown-clinic-title">CAMBIAR DE CLÍNICA</li>
              <li nz-menu-item *ngFor="let userClinic of userClinics" (click)="onGoToClinic(userClinic._id)"> {{ userClinic?.name || '' }} </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>



<ng-template #logo>
  <div class="l-logo">
    <img class="tw-object-contain tw-p-1" loading="lazy" [src]="clinic?.logo ? clinic?.logo : './../../../assets/images/logo_clinic.png'">
  </div>
</ng-template>

<ng-template #userImage>
  <div class="l-user-avatar">
    <app-avatar-user [image]="user?.profileImageURL" [name]="user?.name" [lastname]="user?.lastname" [width]="50"></app-avatar-user>
  </div>
</ng-template>
